import * as React from "react";
import './index.css';
import MainContent from "./MainContent";

const App: React.FC = () => {

    return (   
        <MainContent/> 
    );
};

export default App;
